import React, { FC, useState } from 'react'

import { Button } from '../../../../../../ui/button'
import { Loader2Icon, Trash2 } from 'lucide-react'

import { usePaymentActions } from '../../../../../../../hooks/usePaymentActions'

import {
  IPaymentsCards,
  IUserACH,
  IUserCard,
  IUserInterface,
} from '../../../../../../../models/users/user.interface'

interface RemoveCardProps {
  card: IUserCard | IUserACH
  paymentsCards: IPaymentsCards
  setPaymentsCards: (cards: IPaymentsCards) => void
  organizer: IUserInterface | null
}
export const RemoveCard: FC<RemoveCardProps> = ({
  paymentsCards,
  setPaymentsCards,
  organizer,
  card,
}) => {
  const { onRemoveCard } = usePaymentActions()

  const [removeLoading, setRemoveLoading] = useState(false)
  return (
    <Button
      variant="ghost"
      disabled={removeLoading}
      size="sm"
      className="relative z-10 p-0 w-4 h-4 opacity-50 hover:opacity-100 transition-all"
      onClick={async (e) => {
        e.preventDefault()
        setRemoveLoading(true)
        await onRemoveCard({
          paymentsCards: paymentsCards,
          setPaymentsCards: setPaymentsCards,
          organizer: organizer,
          cartPmId: card.pmId,
        })
        setRemoveLoading(false)
      }}
    >
      {removeLoading ? (
        <Loader2Icon className="animate-spin w-4" />
      ) : (
        <Trash2 className="w-4 text-SeabiscuitDark200ThemeColor" />
      )}
    </Button>
  )
}
